import { useEffect, useState } from 'react';
import { color, typeStyle } from '@m/alchemy-theme';
import styled from 'styled-components';
import { ArrowDownIcon } from '@m/alchemy-ui/icons/ArrowDownIcon';
import { ArrowUpIcon } from '@m/alchemy-ui/icons/ArrowUpIcon';
import { NakedButton } from '@m/alchemy-ui/NakedButton';
import { Select } from '@m/alchemy-ui/Select';

const StyledSelect = styled(Select)`
  button {
    border: none;
    background: transparent;
  }
`;

const StyledNakedButton = styled(NakedButton)`
  color: ${color('contrast', { palette: 'illustrativeLightBlue' })};
  span {
    ${typeStyle('actionM')};
  }
`;

const LanguagePicker = () => {
  const [languages, setLanguages] = useState([]);
  const [selectedLang, setSelectedLang] = useState(null);

  useEffect(() => {
    window.Localize.getAvailableLanguages((err, languages) => {
      // eslint-disable-next-line no-console
      if (err) return console.warn(err);
      const langOptions = languages?.map(({ code, name }) => ({ label: name, value: code }));
      setLanguages(langOptions);
      const selected = langOptions.find(({ value }) => value === window.Localize.getLanguage());
      setSelectedLang(selected);
    });
  }, []);

  const onChange = selected => {
    window.Localize.setLanguage(selected.value);
    setSelectedLang(selected);
  };

  return (
    <StyledSelect
      className="language-picker"
      value={selectedLang?.value}
      onChange={onChange}
      options={languages}
      renderToggle={({
        toggleRef,
        options,
        ...toggleProps
      }) => {
        return (
          <StyledNakedButton className="flex" ref={toggleRef} {...toggleProps}>
            <span className="margin-right-smallish">
              {selectedLang?.label || 'Select Language'}
            </span>
            {toggleProps['aria-expanded'] ? (
              <ArrowUpIcon aria-hidden />
            ) : (
              <ArrowDownIcon aria-hidden />
            )}
          </StyledNakedButton>
        );
      }}
    />
  );
};

export default LanguagePicker;
